import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ErrorContainer from './ErrorContainer';
import { Button } from 'src/UIComponents';

function NotFound({ ...props }) {
  let location = useLocation();
  let navigate = useNavigate();

  return (
    <ErrorContainer
      {...props}
      title="404: Route not found"
      message={`
        ${location.pathname}
        ${location.search}
        ${location.hash}
      `}
    >
      <Button onClick={() => navigate(-1)}>Go back</Button>
    </ErrorContainer>
  );
}

NotFound.defaultProps = {
  className: '',
};

export default NotFound;
